import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { Helper } from '../../../../../utils/helper';
import { CommonModule } from '@angular/common'; // Import CommonModule

import { ReactiveFormsModule } from '@angular/forms';

import { BlockTextComponent } from '../../../common/block-text/block-text.component';
import {
  SubjectModel,
  SubjectVariables,
} from '../../../../../models/email-template/subject.interface';
import { NotificationComponent } from '../../../common/notification/notification.component';
import { PinComponent } from '../../../common/pin/pin.component';
import { BaseComponent } from '../../../common/BaseComponent';
import { NotificationInitVariables } from '../../../../../models/template/notifications-model.interface';

@Component({
    selector: 'app-subject',
    imports: [
        CommonModule,
        ReactiveFormsModule,
        BlockTextComponent,
        NotificationComponent,
        PinComponent,
    ],
    templateUrl: './subject.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './subject.component.scss'
})
export class SubjectComponent extends BaseComponent {
  @Input() block: SubjectModel = {
    blockId: '',
    name: '',
    count: 0,
    variables: {
      Subject: '',
    },
    notifications: [new NotificationInitVariables()],
  };
  @Input() isPreview = false;
  count: number = 0;
  @Output() blockData = new EventEmitter<any>();
  @Output() removeBlockEvent = new EventEmitter<string | null>();

  //placeholders:
  subjectPlaceholder: string = 'Enter Subject';

  removeBlock(): void {
    this.removeBlockEvent.emit(this.block.blockId);
  }

  onChange(value: any, fieldName: keyof SubjectVariables) {
    if (this.block.variables) {
      this.block.variables[fieldName] = value;
      this.blockData.emit(this.block);
    }
  }

  onContainerClick(event: MouseEvent) {
    // Forward the click event to the child app-pin component
    this.pinComponent.onContainerClick(event);
  }
}
